/// <reference path="./../Container/Container.ts" />
namespace HA.Core.HTML.Menu {
    export class AppMenu extends Container {

        public addItems(menuData: Map<any, any>[]): void {
            const items: List = this.getItemsContainer();
            const me = this;
            items.clear();
            menuData.forEach((e: Map<string, string>) => {
                const a = new Anchor(toMap({
                    d: JSON.stringify(e.get("d")),
                    n: () => {
                        me.hide();
                    },
                    t: e.get("t"),
                }));
                a.appendChild(new MenuItem(e));
                items.addItem(a);
            });
        }

        protected getItemsContainer(): List {
            return this.get("items");
        }

        protected initialize(data: any) {
            super.initialize(data);
            const itemsContainer = new List({tag: new CFlexContainer({class: "menus"})});
            const ic = new Div({classes: ["menupane", "ic"]});
            ic.appendChild(itemsContainer);
            this.appendChild(ic);
            this.addClass("overlay");
            this.addToData("items", itemsContainer);
            const me = this;

            this.onClick(() => {
                me.hide();
            });

        }
    }

}
